export default "__VITE_ASSET__BKUho3Qw__"